export enum ToastType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
}

export interface ToastState {
  message: string;
  type: ToastType;
}

export interface ToastSlice {
  toast: ToastState | null;
  showToast: (message: string, type?: ToastType) => void;
  hideToast: () => void;
}
